export const AVAILABILIES = "AVAILABILIES";
export const AVAILABILITY_COUNT = "AVAILABILITY_COUNT";
export const AVAILABILITY_SELECTED = "AVAILABILITY_SELECTED";
